import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  private env = (window as any).__env;

  constructor() {
  }

  get production(): boolean {
    return this.env.production === true;
  }

  get ampKey(): string {
    return this.env.amp_key || '';
  }

  get baseUrl(): string {
    return this.env.baseUrl || '';
  }

  get analyticsUrl(): string {
    return this.env.analyticsUrl || '';
  }

  get appServiceUrl(): string {
    return this.env.appServiceUrl || '';
  }

  get webappurl(): string {
    return this.env.webappurl || '';
  }

  get webapplink(): string {
    return this.env.webapplink || '';
  }

  get webUrl(): string {
    return this.env.webUrl || '';
  }

  get newIncidentPortalLink(): string {
    return this.env.newIncidentPortalLink || '';
  }

  get replyURL(): string {
    return this.env.replyURL || '';
  }

  get identifier(): string {
    return this.env.identifier || '';
  }

  get signOnUrl(): string {
    return this.env.signOnUrl || '';
  }

  get callBackUrl(): string {
    return this.env.callBackUrl || '';
  }

  get schedule_mongo(): string {
    return this.env.schedule_mongo || '';
  }

  get newDashboardUrl(): string {
    return this.env.newDashboardUrl || '';
  }

  get firebaseConfig(): any {
    return this.env?.firebaseConfig || {};
  }

  get ssoLogoutEndpoint(): string {
    return this.env.ssoLogoutEndpoint || '';
  }

  get chargebeeuksite(): string {
    return this.env.chargebeeuksite || '';
  }

  get chargebeeussite(): string {
    return this.env.chargebeeussite || '';
  }

  get dashboardurl(): string {
    return this.env.dashboardurl || '';
  }

  get ssologinurl(): string {
    return this.env.ssologinurl || '';
  }

  get incidentportalurl(): string {
    return this.env.incidentportalurl || '';
  }

  get googlesignurl(): string {
    return this.env.googlesignurl || '';
  }

  get googlesignupurl(): string {
    return this.env.googlesignupurl || '';
  }

  get microsoftlogignurl(): string {
    return this.env.microsoftlogignurl || '';
  }

  get microsoftsignupurl(): string {
    return this.env.microsoftsignupurl || '';
  }

  get incidentBaseUrl(): string {
    return this.env.incidentBaseUrl || '';
  }

  get portalUrl(): string {
    return this.env.portalUrl || '';
  }

  get otpUrl(): string {
    return this.env.otpUrl || '';
  }

  get scheduleurl(): string {
    return this.env.scheduleurl || '';
  }

  get notification_url(): string {
    return this.env.notification_url || '';
  }

  get appservice_url(): string {
    return this.env.appservice_url || '';
  }

  get followupurl(): string {
    return this.env.followupurl || '';
  }

  get ssoLoginUrl(): string {
    return this.env.ssoLoginUrl || '';
  }

  get ssoLogoutUrl(): string {
    return this.env.ssoLogoutUrl || '';
  }

  get ssogogleurl(): string {
    return this.env.ssogogleurl || '';
  }

  get ssomicrourl(): string {
    return this.env.ssomicrourl || '';
  }

  get cloudapi(): string {
    return this.env.cloudapi || '';
  }

  get cloudupload_preset(): string {
    return this.env.cloudupload_preset || '';
  }

  get cloudcloudname(): string {
    return this.env.cloudcloudname || '';
  }

  get adminUrl(): string {
    return this.env.adminUrl || '';
  }
    get posthogKey(): string {
    return this.env.posthogKey || '';
  }
  get posthogHost(): string {
    return this.env.posthogHost || '';
  }

  get exportExcelUrl(): string {
    return this.env.excel_export_url || '';
  }

  get goaudits2Url(): string {
    return this.env.goaudits2Url || '';
  }

  get goaudits2AuthApiUrl(): string {
    return this.env.goaudits2AuthApiUrl || '';
  }
}